import HisAI from "./library/his-ai";
import HisAlertCircle from "./library/his-alert-circle";
import HisArrowDown from "./library/his-arrow-down";
import HisArrowUp from "./library/his-arrow-up";
import HisAvatar from "./library/his-avatar";
import HisCalculator from "./library/his-calculator";
import HisCalendar from "./library/his-calendar";
import HisCalendarCheck from "./library/his-calendar-check";
import HisCalendarPlus from "./library/his-calendar-plus";
import HisCalendarSearch from "./library/his-calendar-search";
import HisChart from "./library/his-chart";
import HisCheck from "./library/his-check";
import HisCheckCircle from "./library/his-check-circle";
import HisCheckCircle2 from "./library/his-check-circle-2";
import HisChevronLeft from "./library/his-chevron-left";
import HisChevronRight from "./library/his-chevron-right";
import HisClipboardCheck from "./library/his-clipboard-check";
import HisClipboardList from "./library/his-clipboard-list";
import HisClock from "./library/his-clock";
import HisContact from "./library/his-contact";
import HisCopy from "./library/his-copy";
import HisDashboard from "./library/his-dashboard";
import HisDollarSign from "./library/his-dollar-sign";
import HisEdit from "./library/his-edit";
import HisEdit3 from "./library/his-edit-3";
import HisErrorSign from "./library/his-error-sign";
import HisEye from "./library/his-eye";
import HisEyeOff from "./library/his-eye-off";
import HisFileSearch from "./library/his-file-search";
import HisFilters from "./library/his-filters";
import HisFolderClock from "./library/his-folder-clock";
import HisFolderSearch from "./library/his-folder-search";
import HisHandshakeHeart from "./library/his-handshake-heart";
import HisInfo from "./library/his-info";
import HisInjection from "./library/his-injection";
import HisLandmark from "./library/his-landmark";
import HisLastClient from "./library/his-last-client";
import HisLawFirm from "./library/his-law-firm";
import HisLayers from "./library/his-layers";
import HisListSort from "./library/his-list-sort";
import HisLogo from "./library/his-logo";
import HisMagnifyingGlass from "./library/his-magnifying-glass";
import HisMapMarker from "./library/his-map-marker";
import HisMapPin from "./library/his-map-pin";
import HisMapPinOutline from "./library/his-map-pin-outline";
import HisMaximize from "./library/his-maximize";
import HisMinimize from "./library/his-minimize";
import HisNotification from "./library/his-notification";
import HisOutlinedCross from "./library/his-outlined-cross";
import HisPaymentCard from "./library/his-payment-card";
import HisPeople from "./library/his-people";
import HisPerson from "./library/his-person";
import HisPersonAdd from "./library/his-person-add";
import HisPersonCheck from "./library/his-person-check";
import HisPhoneOutgoing from "./library/his-phone-outgoing";
import HisPin from "./library/his-pin";
import HisPlus from "./library/his-plus";
import HisPlusCircle from "./library/his-plus-circle";
import HisRecentDocuments from "./library/his-recent-documents";
import HisSearch from "./library/his-search";
import HisSearch2 from "./library/his-search-2";
import HisShieldCheck from "./library/his-shield-check";
import HisStethoscope from "./library/his-stethoscope";
import HisTrash2 from "./library/his-trash-2";
import HisTrendingDown from "./library/his-trending-down";
import HisUser from "./library/his-user";
import HisX from "./library/his-x";
import Particles1 from "./library/particles1";
import Particles2 from "./library/particles2";
import Particles3 from "./library/particles3";

export class SvgEnum {
  static HisAvatar = "his-avatar";
  static HisCalendar = "his-calendar";
  static HisCalendarCheck = "his-calendar-check";
  static HisCalendarPlus = "his-calendar-plus";
  static HisCalendarSearch = "his-calendar-search";
  static HisCalculator = "his-calculator";
  static HisChart = "his-chart";
  static HisDashboard = "his-dashboard";
  static HisEdit = "his-edit";
  static HisFilters = "his-filters";
  static HisFileSearch = "his-file-search";
  static HisHandshakeHeart = "his-handshake-heart";
  static HisLastClient = "his-last-client";
  static HisLayers = "his-layers";
  static HisListSort = "his-list-sort";
  static HisLogo = "his-logo";
  static HisMagnifyingGlass = "his-magnifying-glass";
  static HisMapMarker = "his-map-marker";
  static HisNotification = "his-notification";
  static HisOutlinedCross = "his-outlined-cross";
  static HisPeople = "his-people";
  static HisPaymentCard = "his-payment-card";
  static HisPerson = "his-person";
  static HisPersonAdd = "his-person-add";
  static HisPersonCheck = "his-person-check";
  static HisPhoneOutgoing = "his-phone-outgoing";
  static HisPlus = "his-plus";
  static HisRecentDocuments = "his-recent-documents";
  static HisSearch = "his-search";
  static Injection = "his-injection";
  static Particles1 = "particles1";
  static Particles2 = "particles2";
  static Particles3 = "particles3";
  static Stethoscope = "his-stethoscope";
  static HisLawFirm = "his-law-firm";
  static HisShieldCheck = "his-shield-check";
  static HisDollarSign = "his-dollar-sign";
  static HisClipboardList = "his-clipboard-list";
  static HisClipboardCheck = "his-clipboard-check";
  static HisClock = "his-clock";
  static HisPlusCircle = "his-plus-circle";
  static HisEdit3 = "his-edit-3";
  static HisX = "his-x";
  static HisCheckCircle2 = "his-check-circle-2";
  static HisCheckCircle = "his-check-circle";
  static HisAlertCircle = "his-alert-circle";
  static HisFolderSearch = "his-folder-search";
  static HisArrowUp = "his-arrow-up";
  static HisArrowDown = "his-arrow-down";
  static HisErrorSign = "his-error-sign";
  static HisPin = "his-pin";
  static HisCopy = "his-copy";
  static HisUser = "his-user";
  static HisInfo = "his-info";
  static HisFolderClock = "his-folder-clock";
  static HisStethoscope = "his-stethoscope";
  static HisLandmark = "his-landmark";
  static HisMapPin = "his-map-pin";
  static HisSearch2 = "his-search-2";
  static HisMinimize = "his-minimize";
  static HisMaximize = "his-maximize";
  static HisEye = "his-eye";
  static HisEyeOff = "his-eye-off";
  static HisAI = "his-ai";
  static HisMapPinOutline = "his-map-pin-outline";
  static HisContact = "his-contact";
  static HisTrash2 = "his-trash-2";
  static HisTrendingDown = "his-trending-down";
  static HisCheck = "his-check";
  static HisChevronRight = "his-chevron-right";
  static HisChevronLeft = "his-chevron-left";
}

const Svg = ({ name, onClick, color, sx }) => {
  const styles = sx;

  let Component;
  switch (name) {
    case SvgEnum.HisAvatar:
      Component = HisAvatar;
      break;

    case SvgEnum.HisCalendar:
      Component = HisCalendar;
      break;

    case SvgEnum.HisCalendarCheck:
      Component = HisCalendarCheck;
      break;

    case SvgEnum.HisCalendarPlus:
      Component = HisCalendarPlus;
      break;

    case SvgEnum.HisCalendarSearch:
      Component = HisCalendarSearch;
      break;

    case SvgEnum.HisCalculator:
      Component = HisCalculator;
      break;

    case SvgEnum.HisChart:
      Component = HisChart;
      break;

    case SvgEnum.HisDashboard:
      Component = HisDashboard;
      break;

    case SvgEnum.HisEdit:
      Component = HisEdit;
      break;

    case SvgEnum.HisFilters:
      Component = HisFilters;
      break;

    case SvgEnum.HisFileSearch:
      Component = HisFileSearch;
      break;

    case SvgEnum.HisHandshakeHeart:
      Component = HisHandshakeHeart;
      break;

    case SvgEnum.HisLastClient:
      Component = HisLastClient;
      break;

    case SvgEnum.HisLayers:
      Component = HisLayers;
      break;

    case SvgEnum.HisListSort:
      Component = HisListSort;
      break;

    case SvgEnum.HisLogo:
      Component = HisLogo;
      break;

    case SvgEnum.HisMagnifyingGlass:
      Component = HisMagnifyingGlass;
      break;

    case SvgEnum.HisMapMarker:
      Component = HisMapMarker;
      break;

    case SvgEnum.HisNotification:
      Component = HisNotification;
      break;

    case SvgEnum.HisOutlinedCross:
      Component = HisOutlinedCross;
      break;

    case SvgEnum.HisPeople:
      Component = HisPeople;
      break;

    case SvgEnum.HisPaymentCard:
      Component = HisPaymentCard;
      break;

    case SvgEnum.HisPerson:
      Component = HisPerson;
      break;

    case SvgEnum.HisPersonAdd:
      Component = HisPersonAdd;
      break;

    case SvgEnum.HisPersonCheck:
      Component = HisPersonCheck;
      break;

    case SvgEnum.HisPlus:
      Component = HisPlus;
      break;

    case SvgEnum.HisRecentDocuments:
      Component = HisRecentDocuments;
      break;

    case SvgEnum.HisSearch:
      Component = HisSearch;
      break;

    case SvgEnum.Particles1:
      Component = Particles1;
      break;

    case SvgEnum.Particles2:
      Component = Particles2;
      break;

    case SvgEnum.Particles3:
      Component = Particles3;
      break;

    case SvgEnum.Stethoscope:
      Component = HisStethoscope;
      break;

    case SvgEnum.Injection:
      Component = HisInjection;
      break;

    case SvgEnum.HisLawFirm:
      Component = HisLawFirm;
      break;

    case SvgEnum.HisShieldCheck:
      Component = HisShieldCheck;
      break;

    case SvgEnum.HisDollarSign:
      Component = HisDollarSign;
      break;

    case SvgEnum.HisPhoneOutgoing:
      Component = HisPhoneOutgoing;
      break;

    case SvgEnum.HisPlusCircle:
      Component = HisPlusCircle;
      break;

    case SvgEnum.HisEdit3:
      Component = HisEdit3;
      break;

    case SvgEnum.HisX:
      Component = HisX;
      break;

    case SvgEnum.HisClipboardList:
      Component = HisClipboardList;
      break;

    case SvgEnum.HisCheckCircle:
      Component = HisCheckCircle;
      break;

    case SvgEnum.HisClipboardCheck:
      Component = HisClipboardCheck;
      break;

    case SvgEnum.HisAlertCircle:
      Component = HisAlertCircle;
      break;

    case SvgEnum.HisFolderSearch:
      Component = HisFolderSearch;
      break;

    case SvgEnum.HisCheckCircle2:
      Component = HisCheckCircle2;
      break;

    case SvgEnum.HisClock:
      Component = HisClock;
      break;

    case SvgEnum.HisArrowUp:
      Component = HisArrowUp;
      break;

    case SvgEnum.HisArrowDown:
      Component = HisArrowDown;
      break;

    case SvgEnum.HisErrorSign:
      Component = HisErrorSign;
      break;

    case SvgEnum.HisPin:
      Component = HisPin;
      break;

    case SvgEnum.HisCopy:
      Component = HisCopy;
      break;

    case SvgEnum.HisUser:
      Component = HisUser;
      break;

    case SvgEnum.HisInfo:
      Component = HisInfo;
      break;

    case SvgEnum.HisFolderClock:
      Component = HisFolderClock;
      break;

    case SvgEnum.HisStethoscope:
      Component = HisStethoscope;
      break;

    case SvgEnum.HisLandmark:
      Component = HisLandmark;
      break;

    case SvgEnum.HisMapPin:
      Component = HisMapPin;
      break;

    case SvgEnum.HisSearch2:
      Component = HisSearch2;
      break;

    case SvgEnum.HisMaximize:
      Component = HisMaximize;
      break;

    case SvgEnum.HisMinimize:
      Component = HisMinimize;
      break;

    case SvgEnum.HisEye:
      Component = HisEye;
      break;

    case SvgEnum.HisEyeOff:
      Component = HisEyeOff;
      break;

    case SvgEnum.HisAI:
      Component = HisAI;
      break;

    case SvgEnum.HisMapPinOutline:
      Component = HisMapPinOutline;
      break;
      
    case SvgEnum.HisContact:
      Component = HisContact;
      break;

    case SvgEnum.HisTrash2:
      Component = HisTrash2;
      break;

    case SvgEnum.HisTrendingDown:
      Component = HisTrendingDown;
      break;

    case SvgEnum.HisCheck:
      Component = HisCheck;
      break;

    case SvgEnum.HisChevronRight:
      Component = HisChevronRight;
      break;

    case SvgEnum.HisChevronLeft:
      Component = HisChevronLeft;
      break;

    case "":
      Component = HisPerson;
      break;

    default:
      throw new Error(`"${name}" is not a recognized option in Svg`);
  }

  const { width, ...wrapperStyles } = styles ?? {};

  const svgSx = { width };
  const _wrapperStyles = {
    display: "inline-block",
    ...wrapperStyles,
  };

  return (
    <span onClick={onClick ?? (() => {})} style={_wrapperStyles}>
      <Component color={color} sx={{ ...sx, ...svgSx }} />
    </span>
  );
};

export default Svg;
